import { timestamps } from './config/timestamps';
import { getOptionState } from './utils/getOptionState';
import styles from './TimeSelector.module.css';
import { Button } from '@blueprintjs/core';

type TimeSelectorProps = {
  disabledTimes?: string[];
  selectedTime?: string;
  onTimeSelect: (time: string) => void;
};

export const TimeSelector = ({
  disabledTimes,
  selectedTime = '',
  onTimeSelect,
}: TimeSelectorProps) => {
  return (
    <div className={styles.timeSelector}>
      {timestamps.map((time) => (
        <Button
          key={time}
          data-state={getOptionState({
            option: time,
            disabledTimes: disabledTimes || [],
            selectedTime,
          })}
          className={styles.timeOption}
          onClick={() => onTimeSelect(time)}
          variant="minimal"
        >
          {time}
        </Button>
      ))}
    </div>
  );
};
